import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import MlUnsyncedProductsComponent from '../components/MlUnsyncedProductsComponent';
import MlFailedOrdersComponent from '../components/MlFailedOrdersComponent';
import FreeShippingAuditComponent from '../components/FreeShippingAuditComponent';
import MlPriceCheckComponent from '../components/MlPriceCheckComponent';
import { validateSession } from '../utils/functions';

// Integración con MercadoLibre. Antes era sólo "Órdenes ML caídas"; los dos paneles son las dos
// puntas del mismo dato (el vínculo producto↔publicación de `external_item`): lo que falta
// vincular, y las ventas que se cayeron justamente por eso. Verlos juntos es lo que permite
// cerrar el círculo sin salir de la pantalla.
//
// El tab arranca en "Sin sincronizar" porque es la vista preventiva; las órdenes caídas son la
// consecuencia y suelen estar vacías.

const TABS = [
    { key: 'unsynced', label: 'Sin sincronizar', subtitle: 'Sin sincronizar' },
    { key: 'failed', label: 'Órdenes caídas', subtitle: 'Órdenes caídas' },
    // Estaba en Configuraciones → Integración ML, junto a las credenciales. Es trabajo
    // operativo sobre las publicaciones, igual que los otros dos tabs; en Configuraciones va
    // sólo la configuración de la cuenta.
    { key: 'freeShipping', label: 'Regalan el envío', subtitle: 'Publicaciones que regalan el envío' },
    // Se alimenta del MISMO barrido que "Regalan el envío" (reconcileStock ya consultaba el
    // precio de cada publicación y lo tiraba), así que vive al lado suyo. Va último porque es
    // la vista analítica: las otras tres son trabajo pendiente, ésta es para decidir precios.
    { key: 'priceCheck', label: 'Precios y margen', subtitle: 'Precio y margen de cada publicación' },
];

class MlIntegrationPage extends Component {
    constructor() {
        const cachedRole = Number(localStorage.getItem('role') || 0);
        super();
        this.state = {
            checked: !!localStorage.getItem('token'),
            role: cachedRole,
            tab: 'unsynced',
        };
    }

    async componentDidMount() {
        const role = await validateSession(true);
        this.setState({ checked: true, role });
    }

    setTab = (tab) => this.setState({ tab });

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        const { tab } = this.state;
        const current = TABS.find((t) => t.key === tab) || TABS[0];

        return (
            <div className="container-fluid">
                <div className="row">
                    {/* 40 y no 25: el 25 es Cafetería en PANELES_ESTADISTICAS, así que el menú
                        resaltaba Estadísticas al entrar acá. Misma clase de bug que ya había pasado
                        con el 28 (Comandas) — ver el comentario de la lista en SidebarComponent. */}
                    <SidebarComponent itemSelected={40} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4" style={{ paddingBottom: '80px' }}>
                            <HeaderComponent title="Integración MercadoLibre" subtitle={current.subtitle} />

                            <ul className="nav nav-tabs mb-3">
                                {TABS.map((t) => (
                                    <li className="nav-item" key={t.key}>
                                        <button type="button"
                                            className={`nav-link ${tab === t.key ? 'active' : ''}`}
                                            style={{ background: 'none', border: 0, borderBottom: tab === t.key ? '2px solid #007bff' : '2px solid transparent' }}
                                            onClick={() => this.setTab(t.key)}>
                                            {t.label}
                                        </button>
                                    </li>
                                ))}
                            </ul>

                            {/* Se montan/desmontan a propósito: cada panel recarga al volver, que es lo
                                que se espera después de ir a vincular una publicación en otra pestaña. */}
                            {tab === 'unsynced' ? <MlUnsyncedProductsComponent /> : null}
                            {tab === 'failed' ? <MlFailedOrdersComponent /> : null}
                            {tab === 'freeShipping' ? <FreeShippingAuditComponent /> : null}
                            {tab === 'priceCheck' ? <MlPriceCheckComponent role={this.state.role} /> : null}
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default MlIntegrationPage;
